import React from "react";
import HeaderBar from "web/react/components/__LEGACY__/app-header/header-bar/header-bar";
import PreHeaderBar from "web/react/components/__LEGACY__/app-header/pre-header-bar/pre-header-bar";
import { SetPaidSessionIdOnLinks } from "web/react/components/set-paid-session-id-on-links/set-paid-session-id-on-links";
import { SkipNavigationButton } from "web/react/components/skip-navigation-button/skip-navigation-button";
import { AppHeaderBarSerializer, AppPreHeaderBarSerializer } from "web/types/serializers";
import "./app-header.module.css";

interface AppHeaderProps {
    headerBar: AppHeaderBarSerializer;
    preHeaderBar: AppPreHeaderBarSerializer;
}

function AppHeader({ headerBar, preHeaderBar }: AppHeaderProps): React.ReactElement {
    return (
        <>
            <SetPaidSessionIdOnLinks />
            <PreHeaderBar
                accountDropdown={preHeaderBar.account_dropdown}
                accountText={preHeaderBar.account_text}
                accountUrl={preHeaderBar.account_url}
                countryInfo={preHeaderBar.country_info}
                languageSelector={preHeaderBar.language_selector}
                registerUrl={preHeaderBar.register_url}
                showCountryPicker={preHeaderBar.show_country_picker}
            />
            <SkipNavigationButton />
            <HeaderBar
                {...headerBar}
                userDropdown={{
                    accountDropdown: preHeaderBar.account_dropdown,
                    accountText: preHeaderBar.account_text,
                    accountUrl: preHeaderBar.account_url,
                    registerUrl: preHeaderBar.register_url,
                }}
            />
            {/* empty div used for header-bar-search React portal */}
            <div id="app-header-search-bar-mobile" className="hidden-desktop" />
        </>
    );
}

export default AppHeader;
